import React from "react";
import { Box, Button, CircularProgress, Modal, Typography } from "@mui/material";
import { Trash, X } from "lucide-react";

function ModalDeleteComponents({ openModal, handleCloseModal, title, titleSecundary, loadingDelete, handleDeleteImage }) {


   

    return (
        <>
    


            <>
                {openModal && (
                    <div
                        className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
                        onClick={(e) => e.target === e.currentTarget && handleCloseModal()}
                    >
                        <div className="w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl">
                            {/* Header */}
                            <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
                                <h2 className="text-base font-bold text-gray-800">
                                    {title}
                                </h2>
                                <button
                                    type="button"
                                    aria-label="cerrar"
                                    onClick={handleCloseModal}
                                    className="rounded-lg p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
                                >
                                    <X size={20} />
                                </button>
                            </div>

                            {/* Consula*/}
                            <div className="flex flex-col items-center px-6 py-8">
                                <p className="text-center text-gray-600 mb-4">
                                    ¿Confirma que desea eliminar la imagen?
                                    {/* {titleSecundary} */}
                                </p>
                            </div>

                            {/* Footer */}
                            <div className="px-6 py-4">
                                <button
                                    type="button"
                                    onClick={handleDeleteImage}
                                    disabled={loadingDelete}
                                    className="flex w-full items-center justify-center gap-2 rounded-lg bg-[#104063] py-2.5 font-semibold text-white transition-colors hover:bg-[#0d3553] disabled:cursor-not-allowed disabled:opacity-70"
                                >
                                    {loadingDelete ? (
                                        <>
                                            <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                                            Eliminando...
                                        </>
                                    ) : (
                                        <>
                                            <Trash size={18} />
                                            Eliminar Imagen
                                        </>
                                    )}
                                </button>

                                <button
                                    type="button"
                                    onClick={handleCloseModal}
                                    className="mt-2 flex w-full items-center justify-center gap-2 rounded-lg bg-gray-300 py-2.5 font-semibold text-gray-700 transition-colors hover:bg-gray-400"
                                >
                                    <>
                                        Cancelar
                                    </>
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </>
        </>
    );
}

export default ModalDeleteComponents;
